import React from "react";

function PendingApprovalPage() {
  return (
    <div style={{ maxWidth: "600px", margin: "50px auto", padding: "20px", textAlign: "center", border: "1px solid #ccc", borderRadius: "8px" }}>
      <h2 style={{ color: "#e67e22" }}>در انتظار تایید مدیریت</h2>
      <p>اطلاعات شما با موفقیت ثبت شد.</p>
      <p>پس از بررسی و تایید مدیر سایت، امکان ورود برای شما فراهم خواهد شد.</p>
      <p>لطفاً کمی صبر کنید.</p>
      <button onClick={() => window.location.href = "/"} style={{ marginTop: "20px", padding: "10px 20px" }}>
        بازگشت به صفحه اصلی
      </button>
    </div>
  );
}

export default PendingApprovalPage;
